import { Provider as ProviderType } from "@ethersproject/providers";
import { ethers } from "ethers";
import { Contract, Provider } from "ethers-multicall";
import feeHandlerabi from "../abis/Fee-Manager.json"
import { BigNumber } from "@ethersproject/bignumber";
import { NetworkType } from "..";

const getFeeFromFeeHandlerMulticaller = ({ feeHandlerAddress, dstChainID, feeTokenAddress }: {
  feeHandlerAddress: string, dstChainID: string, feeTokenAddress: string
}) => {

  const feeHandlerInstance = new Contract(
    feeHandlerAddress,  
    feeHandlerabi
  );

  return feeHandlerInstance.getFeeSafe(dstChainID, feeTokenAddress);

};

const getFeeTokens = async ({ feeHandlerAddress,
  provider,
  dstChainID }: { feeHandlerAddress: string; provider: ProviderType; dstChainID: string }) => {
  const feeHandlerInstance = new ethers.Contract(
    feeHandlerAddress,
    feeHandlerabi,
    provider
  );

  try {
    const tokens = await feeHandlerInstance.getChainFeeTokens(dstChainID);
    return tokens;
  } catch (e) {
    console.log("Fee handler error - ", e);
  }
};
//return (fees._transferFee, fees._exchangeFee, fees.accepted);
export const getFeeAmount = async ({  sourceProvider, sourceNetworkId,destNetworkId,network_config }: { sourceProvider: ProviderType, sourceNetworkId: string,destNetworkId: string,network_config:{ [chainId: string]: NetworkType }
}) => {
  const ethcallProvider = new Provider(sourceProvider, Number(sourceNetworkId))
  const sourceFeeHandlerAddress=network_config[sourceNetworkId].feeHandler;
  const destChainId=network_config[destNetworkId].id;


  const feeTokenList = await getFeeTokens({
    feeHandlerAddress: sourceFeeHandlerAddress,
    provider: sourceProvider,
    dstChainID: destChainId
  })

  const contractCalls = feeTokenList.map((feeTokenAddress: string) => getFeeFromFeeHandlerMulticaller({
    feeHandlerAddress: sourceFeeHandlerAddress,
    dstChainID: destChainId,
    feeTokenAddress: feeTokenAddress
  }))

  const feeArray = await ethcallProvider.all(contractCalls)

  const newFeeTokenList: {
    address: string;
    transferFee: BigNumber;
    exchangeFee: BigNumber;
  }[] = []

  feeTokenList.forEach((feeTokenAddress: string, index: number) => {
    if (feeArray[index][2]) {
      const feeObject = {
        address: feeTokenAddress,
        transferFee: feeArray[index][0],
        exchangeFee: feeArray[index][1],
      }
      newFeeTokenList.push(feeObject)
    }
  })

  return newFeeTokenList
} 